<template>
  <v-container fluid grid-list-xl>
    <v-layout wrap align-start>
      <!-- Agent picker -->
      <v-flex sm2 d-flex v-if="user.role_id == 1">
        <v-select
          v-model="filters.agents"
          :items="agents"
          :loading="loadingAgents"
          item-text="fullname"
          item-value="id"
          label="Agent"
          @change="filter"
          chips
          multiple
          dense
          solo
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.fullname }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text caption">
              (+{{ filters.agents.length - 1 }})
            </span>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="selectAllAgents">
              <v-list-item-action>
                <v-icon
                  :color="filters.agents.length > 0 ? 'indigo darken-4' : ''"
                >
                  {{ agentIcon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Select All </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </v-select>
      </v-flex>
      <!-- Source picker -->
      <v-flex sm2 d-flex>
        <v-select
          v-model="filters.sources"
          :items="sources"
          :loading="loadingSources"
          item-text="title"
          item-value="id"
          label="Lead Type"
          @change="filter"
          chips
          multiple
          dense
          solo
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.title }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text caption">
              (+{{ filters.agents.length - 1 }})
            </span>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="selectAllSources">
              <v-list-item-action>
                <v-icon
                  :color="filters.agents.length > 0 ? 'indigo darken-4' : ''"
                >
                  {{ sourceIcon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Select All </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </v-select>
      </v-flex>
      <!-- Type picker -->
      <v-flex sm2 d-flex>
        <v-select
          v-model="filters.types"
          :items="types"
          item-text="title"
          item-value="id"
          label="Line of business"
          @change="filter"
          chips
          multiple
          dense
          solo
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.title }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text caption">
              (+{{ filters.types.length - 1 }})
            </span>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="selectAllTypes">
              <v-list-item-action>
                <v-icon
                  :color="filters.agents.length > 0 ? 'indigo darken-4' : ''"
                >
                  {{ typesIcon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Select All </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </v-select>
      </v-flex>
      <!-- Date range picker -->
      <v-flex sm2 class="pt-0" d-flex>
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value="dateRangeText"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="dateRangeText"
              label="Picker date range"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dates"
            @change="selectDate"
            no-title
            scrollable
            range
          >
            <v-btn text color="primary" @click="clear"> Clear </v-btn>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
            <v-btn text color="primary" @click="$refs.menu.save(dates)">
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex sm2 d-flex>
        <v-btn height="40" depressed @click="clearFilters">
          Clear filters
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "StatisticFilters",
  props: ["user"],
  data() {
    return {
      dateRangeText: null,
      dates: [],
      menu: false,
      types: [
        // { id: 1, title: "Auto" },
        { id: 2, title: "Life" },
        // { id: 3, title: "Moto" },
        { id: 4, title: "Health" },
        // { id: 5, title: "Renters" },
        // { id: 6, title: "Medicare" },
        // { id: 7, title: "Pet" },
      ],
    };
  },
  methods: {
    ...mapMutations({
      SET_AGENT_FILTER: "statistic/SET_AGENT_FILTER",
      SET_TYPE_FILTER: "statistic/SET_TYPE_FILTER",
      SET_SOURCE_FILTER: "statistic/SET_SOURCE_FILTER",
      SET_DATE_FILTER: "statistic/SET_DATE_FILTER",
    }),
    ...mapActions({
      loadStatistic: "statistic/loadStatistic",
    }),
    clearFilters() {
      this.setAllTypes();
      this.setAllSources();
      this.setAllAgents();
    },
    filter() {
      this.SET_AGENT_FILTER(this.filters.agents);
      this.SET_TYPE_FILTER(this.filters.types);
      this.SET_SOURCE_FILTER(this.filters.sources);
      this.SET_DATE_FILTER(this.dates);
      this.loadStatistic();
    },
    formatDate(date) {
      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    selectAllAgents() {
      if (this.filters.agents.length === this.agents.length) {
        this.filters.agents = [];
      } else {
        this.setAllAgents();
      }
      this.SET_AGENT_FILTER(this.filters.agents);
      this.loadStatistic();
    },
    setAllAgents() {
      if (this.user.role_id == 1) {
        this.filters.agents = [];
        this.agents.forEach((agent) => {
          this.filters.agents.push(agent.id);
        });
      } else if (this.user.role_id == 2) {
        this.filters.agents = [this.user.id];
      }
    },
    selectAllTypes() {
      if (this.filters.types.length === this.types.length) {
        this.filters.types = [];
      } else {
        this.setAllTypes();
      }

      this.SET_TYPE_FILTER(this.filters.types);
      this.loadStatistic();
    },
    setAllTypes() {
      this.filters.types = [];
      this.types.forEach((type) => {
        this.filters.types.push(type.id);
      });
    },
    selectAllSources() {
      if (this.filters.sources.length === this.sources.length) {
        this.filters.sources = [];
      } else {
        this.setAllSources();
      }
      this.SET_SOURCE_FILTER(this.filters.sources);
      this.loadStatistic();
    },
    setAllSources() {
      this.filters.sources = [];
      this.sources.forEach((source) => {
        this.filters.sources.push(source.id);
      });
    },
    selectDate() {
      this.SET_DATE_FILTER(this.dates);
      this.loadStatistic();
      this.updateRangePickerText();
    },
    clear() {
      this.dates = [];
      this.SET_DATE_FILTER(this.dates);
      this.updateRangePickerText();
      this.loadStatistic();
    },
    updateRangePickerText() {
      this.dateRangeText = [];
      if (this.dates.length) {
        let formatedDates = this.dates.map((d) => {
          return this.formatDate(d);
        });

        this.dateRangeText = formatedDates.join(" ~ ");
      }
    },
  },
  computed: {
    ...mapGetters({
      agents: "agents/agents",
      loadingAgents: "agents/loadingAgents",
      sources: "sources/sources",
      loadingSources: "sources/loadingSources",
      filters: "statistic/filters",
    }),
    agentIcon() {
      if (this.filters.agents.length === this.agents.length) {
        return "mdi-close-box";
      }
      if (
        this.filters.agents.length < this.agents.length &&
        this.filters.agents.length > 0
      ) {
        return "mdi-minus-box";
      }
      return "mdi-checkbox-blank-outline";
    },
    sourceIcon() {
      if (this.filters.sources.length === this.sources.length) {
        return "mdi-close-box";
      }
      if (
        this.filters.sources.length < this.sources.length &&
        this.filters.sources.length > 0
      ) {
        return "mdi-minus-box";
      }
      return "mdi-checkbox-blank-outline";
    },
    typesIcon() {
      if (this.filters.types.length === this.types.length) {
        return "mdi-close-box";
      }
      if (
        this.filters.types.length < this.types.length &&
        this.filters.types.length > 0
      ) {
        return "mdi-minus-box";
      }
      return "mdi-checkbox-blank-outline";
    },
  },
  mounted() {
    this.dates = this.filters.date;
    this.updateRangePickerText();
    if (this.user.role_id == 2) {
      this.SET_AGENT_FILTER([this.user.id]);
    }
  },
};
</script>